// extracted by mini-css-extract-plugin
module.exports = {"input-array-item":"SellerForm_input-array-item__2oG2F","icon":"SellerForm_icon__eRbC8"};